import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "table-header-item-count" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-red" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  colspan: 6,
  class: "pr-5"
}
const _hoisted_7 = {
  key: 0,
  style: {"text-decoration":"underline"}
}
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "pb-0" }
const _hoisted_14 = { class: "pb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_TextHighlights = _resolveComponent("TextHighlights")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_SingleFilter = _resolveComponent("SingleFilter")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_NowhowDatepicker = _resolveComponent("NowhowDatepicker")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_FilterDrawer = _resolveComponent("FilterDrawer")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_infinite_scroll, { onLoad: _ctx.load }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    expanded: _ctx.expanded,
                    "onUpdate:expanded": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.expanded) = $event)),
                    "sort-by": _ctx.sortBy,
                    "onUpdate:sortBy": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sortBy) = $event)),
                      _ctx.onSortByChanged
                    ],
                    headers: _ctx.headers,
                    items: _ctx.lieferantenrechnungenList,
                    "item-value": "pdfDokumentGuid",
                    "show-expand": "",
                    loading: _ctx.loading,
                    "hide-default-footer": "",
                    class: "elevation-1",
                    "items-length": _ctx.totalNumberOfRecords || 0,
                    "must-sort": true,
                    "custom-sort": _ctx.customSort,
                    hover: "",
                    "onClick:row": _ctx.expandRow
                  }, {
                    top: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_col, {
                          sm: "12",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { cols: "auto" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h3", {
                                      class: "pl-3",
                                      textContent: _toDisplayString(_ctx.$t('praxisgruppe.rechnungen.list.title'))
                                    }, null, 8, _hoisted_1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "auto" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn, _mergeProps({
                                          class: "px-1 mr-2",
                                          style: {"min-width":"160px"},
                                          color: "primary"
                                        }, props, { onClick: _ctx.downloadXml }), {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('praxisgruppe.rechnungen.button.download.xml')), 1)
                                          ]),
                                          _: 2
                                        }, 1040, ["onClick"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('praxisgruppe.rechnungen.tooltip.download.xml')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "auto" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn, _mergeProps({
                                          class: "px-1 mr-2",
                                          style: {"min-width":"160px"},
                                          color: "primary"
                                        }, props, { onClick: _ctx.downloadCsv }), {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('praxisgruppe.rechnungen.button.download.csv')), 1)
                                          ]),
                                          _: 2
                                        }, 1040, ["onClick"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('praxisgruppe.rechnungen.tooltip.download.csv')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_TableHeader, {
                          filters: _ctx.filters,
                          onChipClosed: _ctx.removeFilter
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.totalNumberOfRecords + ' ' + _ctx.$t('archiv.table.header.items')), 1),
                            (_ctx.showSearchBar)
                              ? (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 0,
                                  modelValue: _ctx.filterData.suchText,
                                  "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterData.suchText) = $event)),
                                    _ctx.searchFieldInputChanged
                                  ],
                                  class: "ml-5",
                                  "prepend-inner-icon": "mdi-magnify",
                                  "append-inner-icon": "mdi-close",
                                  label: _ctx.$t('lieferantrechnungen.suchfeld'),
                                  "hide-details": "",
                                  autofocus: "",
                                  "onClick:appendInner": _ctx.searchBarClosed
                                }, null, 8, ["modelValue", "label", "onUpdate:modelValue", "onClick:appendInner"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_tooltip, {
                              top: "",
                              color: "secondary"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  icon: "",
                                  color: "primary"
                                }), {
                                  default: _withCtx(() => [
                                    (!_ctx.showSearchBar)
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchBar = !_ctx.showSearchBar))
                                        }, {
                                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                                            _createTextVNode("mdi-magnify")
                                          ])),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.search')), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_tooltip, {
                              top: "",
                              color: "secondary"
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps(props, {
                                  icon: "",
                                  color: "primary",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterDrawer = !_ctx.showFilterDrawer))
                                }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode("mdi-filter-outline")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.filter')), 1)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["filters", "onChipClosed"])
                      ])
                    ]),
                    "item.lieferantName": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.lieferantName,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.rechnungNummer": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.rechnungNummer,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.betrag": _withCtx(({ item }) => [
                      (item.lieferantDokumentTyp === 'Rechnung')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                            _createElementVNode("span", _hoisted_4, "-" + _toDisplayString(_ctx.formatNumber(item.betrag)), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.formatNumber(item.betrag)), 1))
                    ]),
                    "item.link": _withCtx(({ item }) => [
                      _createVNode(_component_v_btn, {
                        icon: "",
                        class: "elevation-0",
                        href: item.link,
                        onClick: [
                          _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                          ($event: any) => (
                                    _ctx.downloadBeleg({
                                        id: item.pdfDokumentGuid,
                                        defaultFileName: `${item.pdfDokumentGuid}.pdf`
                                    })
                                )
                        ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "primary",
                            icon: "mdi-download-outline"
                          })
                        ]),
                        _: 2
                      }, 1032, ["href", "onClick"])
                    ]),
                    "item.data-table-expand": _withCtx(({ item }) => [
                      _createVNode(_component_v_btn, {
                        icon: "",
                        class: "elevation-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.isRowExpanded(item) ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    "expanded-row": _withCtx(({}) => [
                      _cache[22] || (_cache[22] = _createElementVNode("td", { class: "d-none d-sm-table-cell" }, null, -1)),
                      _createElementVNode("td", _hoisted_6, [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_data_table, {
                                  headers: _ctx.subHeaders,
                                  items: _ctx.lieferantenrechungDetails,
                                  "disable-pagination": "",
                                  density: "compact",
                                  "item-value": "produktNummer",
                                  class: "bg-surface-light elevation-2 rounded-b-lg pa-3 ma-3",
                                  "hide-default-footer": "",
                                  hover: "",
                                  "items-per-page": -1
                                }, {
                                  "item.produkteNummer": _withCtx(({ item }) => [
                                    _createVNode(_component_TextHighlights, {
                                      text: item.produkteNummer,
                                      "search-text": _ctx.filterData.suchText
                                    }, null, 8, ["text", "search-text"])
                                  ]),
                                  "item.produktBezeichnung": _withCtx(({ item }) => [
                                    (item.produktNummerVetpoint)
                                      ? (_openBlock(), _createElementBlock("a", _hoisted_7, [
                                          _createVNode(_component_TextHighlights, {
                                            text: item.produktBezeichnung,
                                            "search-text": _ctx.filterData.suchText,
                                            onClick: ($event: any) => (_ctx.openProduktNummerVetpointTab(item.produktNummerVetpoint))
                                          }, null, 8, ["text", "search-text", "onClick"])
                                        ]))
                                      : (_openBlock(), _createBlock(_component_TextHighlights, {
                                          key: 1,
                                          text: item.produktBezeichnung,
                                          "search-text": _ctx.filterData.suchText,
                                          onClick: ($event: any) => (_ctx.openProduktNummerVetpointTab(item.produktNummerVetpoint))
                                        }, null, 8, ["text", "search-text", "onClick"]))
                                  ]),
                                  "item.anzahl": _withCtx(({ item }) => [
                                    _createElementVNode("span", {
                                      textContent: _toDisplayString(item.anzahl.toFixed(3))
                                    }, null, 8, _hoisted_8)
                                  ]),
                                  "item.einheit": _withCtx(({ item }) => [
                                    (_ctx.language === 'de')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.einheitTextDe), 1))
                                      : _createCommentVNode("", true),
                                    (_ctx.language === 'fr')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.einheitTextFr), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  "item.einzelPreis": _withCtx(({ item }) => [
                                    _createElementVNode("span", {
                                      textContent: _toDisplayString(_ctx.formatNumber(item.einzelPreis))
                                    }, null, 8, _hoisted_11)
                                  ]),
                                  "item.betragInklusivMwst": _withCtx(({ item }) => [
                                    _createElementVNode("span", {
                                      textContent: _toDisplayString(_ctx.formatNumber(item.betragInklusivMwst))
                                    }, null, 8, _hoisted_12)
                                  ]),
                                  _: 1
                                }, 8, ["headers", "items"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["expanded", "sort-by", "headers", "items", "loading", "items-length", "custom-sort", "onClick:row", "onUpdate:sortBy"])
                ]),
                _: 1
              }, 8, ["onLoad"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FilterDrawer, {
        visible: _ctx.showFilterDrawer,
        "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showFilterDrawer) = $event)),
        onCancel: _cache[16] || (_cache[16] = ($event: any) => (_ctx.cancelFilter())),
        onConfirm: _cache[17] || (_cache[17] = ($event: any) => (_ctx.confirmFilter())),
        onClear: _cache[18] || (_cache[18] = ($event: any) => (_ctx.clearAllFilters(true))),
        onReset: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clearAllFilters(false)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SingleFilter, {
            title: _ctx.$t('rechnungen.filter.header.tvskundevonzugriffe')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { sm: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.filterData.tvsKundeTeilnehmerIdsForFilter,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterData.tvsKundeTeilnehmerIdsForFilter) = $event)),
                        variant: "filled",
                        density: "compact",
                        "hide-details": "",
                        items: _ctx.tvsKundenVonZugriffe
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_SingleFilter, { title: "" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.radios,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.radios) = $event)),
                    class: "mt-0",
                    inline: ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.$t('archiv.filter.title.datum')), 1),
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            value: "specificTime",
                            label: _ctx.$t('rechnungen.filter.label.specifictime')
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        sm: "12",
                        class: "pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_NowhowDatepicker, {
                                    modelValue: _ctx.filterData.rechnungDatumVon,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filterData.rechnungDatumVon) = $event)),
                                    disabled: _ctx.radios !== 'specificTime',
                                    label: "archiv.filter.datum.von",
                                    onChange: _ctx.onRechnungsDatumVonChange
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_NowhowDatepicker, {
                                    modelValue: _ctx.filterData.rechnungDatumBis,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filterData.rechnungDatumBis) = $event)),
                                    disabled: _ctx.radios !== 'specificTime',
                                    label: "archiv.filter.datum.bis",
                                    onChange: _ctx.onRechnungsDatumBisChange
                                  }, null, 8, ["modelValue", "disabled", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            value: "selectTime",
                            label: _ctx.$t('rechnungen.filter.label.selecttime')
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-0 pb-8"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            modelValue: _ctx.filterData.zeitspanne,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filterData.zeitspanne) = $event)),
                            disabled: _ctx.radios !== 'selectTime',
                            variant: "filled",
                            density: "compact",
                            "hide-details": "",
                            items: _ctx.ddTimeItems
                          }, null, 8, ["modelValue", "disabled", "items"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pt-0 pb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_radio, {
                            value: "allTime",
                            label: _ctx.$t('kontobrowser.filter.alltime')
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.$t('kontobrowser.filter.title.betrag')), 1),
                  _createVNode(_component_v_row, { class: "pb-6 filterLine" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.filterData.betragVon,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filterData.betragVon) = $event)),
                            "hide-details": "",
                            variant: "filled",
                            density: "compact",
                            label: _ctx.$t('rechnungen.filter.label.betragvon'),
                            onKeypress: _cache[12] || (_cache[12] = ($event: any) => (_ctx.checkInputCharacter($event)))
                          }, null, 8, ["modelValue", "label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.filterData.betragBis,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filterData.betragBis) = $event)),
                            "hide-details": "",
                            variant: "filled",
                            density: "compact",
                            label: _ctx.$t('rechnungen.filter.label.betragbis'),
                            onKeypress: _cache[14] || (_cache[14] = ($event: any) => (_ctx.checkInputCharacter($event)))
                          }, null, 8, ["modelValue", "label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}